import React, { useState } from 'react';
import './RydLogin.css';
import { useNavigate } from 'react-router';

interface LoginProps {
    onLogin?: (email: string, password: string) => void;
}

const RydLogin: React.FC<LoginProps> = ({ onLogin }) => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');

    const navigate = useNavigate();

    const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        setError('');

        if (!email || !password) {
            setError('Please enter both email and password.');
            return;
        }

        // Handle login logic
        if (onLogin) {
            onLogin(email, password);
        } else {
            console.log('Logging in with:', email, password);
        }
    };

    return (<>
        <div id="header">
                <div id="logo">
                    {/* <img src={logo} height={28} /> */}
                    <h1>rydice</h1>
                </div>
        </div>
        <div className={'ryd-login-container'}>
            <h2 className={'ryd-login-title'}>Login</h2>
            <form onSubmit={handleSubmit} className='ryd-login-form'>
                {error && <p className='ryd-login-error'>{error}</p>}
                <div className='ryd-login-input-group'>
                    <label htmlFor="email" className='ryd-login-label'>Email:</label>
                    <input
                        id="email"
                        type="email"
                        placeholder="your.email@example.com"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        className='ryd-login-input'
                    />
                </div>
                <div className='ryd-login-input-group'>
                    <label htmlFor="password" className='ryd-login-label'>Password:</label>
                    <input
                        id="password"
                        type="password"
                        placeholder="Your password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        className='ryd-login-input'
                    />
                </div>
                <button type="submit" className='ryd-login-button'
                    onClick={() => navigate('/app')}>Login</button>
            </form>
        </div>
        </>);
};

export default RydLogin;